import React from 'react';
import "./css-files/moneyBuilderMedia.css";
import { connect } from 'react-redux';
import { setInfo } from '../../redux/actionList';
import accountTypeOverview from './text/account_type_overview';
import ConductorDashboardInfoCard from './conductor_dashboard_info_card';
import ConductorDashboardDataCard from './conductor_dashboard_data_card';
import withLocation from '../../objects/CommonUse/with_location';
import createOverviewProfile from './xMoneyBuilderObjects/create_overview_profile';
import determineMonthlySavingsAmt from '../shared-components/objects/determineMonthlySavingsAmt';
import { doubleToStringMonthly } from '../../objects/CommonUse/double_functions';
import { calcMonthlyIncome } from '../../objects/CommonUse/calcMonthlyIncome';

// mapStateToProps: pick the Redux state your component needs
const mapStateToProps = (state) => ({
    prevProcess: state.prevProcess,
    // add other Redux state slices here if needed
});

// mapDispatchToProps: make Redux actions available as props
const mapDispatchToProps = {
    setInfoRedux: setInfo,
};


class ConductorDashboard extends React.Component {
    constructor(props) {
        super(props);
        this.moneyBuildInfo = this.props.moneyBuildInfo();
        this.state = {
      
        }  
        this.portfolioArr = [];
        this.displayPortfolio = false;
        this.previousProcess = "";
        this.overviewTextArr = [];
        this.summaryArr = [];
        this.initialization();
    }

initialization(){
    this.props.onOpen(0);
    this.loadInformationArr();
    this.savePreviousProcess();
    this.determineDisplayClasses();
}

loadInformationArr(){
    const accountOverviewText = accountTypeOverview;
    for (let i=0; i<accountOverviewText.length; i++){
        if (accountOverviewText[i].level <= this.props.level){
            this.overviewTextArr.push(accountOverviewText[i]);
        }
    }
}
savePreviousProcess(){
    this.previousProcess = this.props.prevProcess;
}

determineDisplayClasses(){
    this.classSize = "col-sm-8 mt-1";
    this.tableClass = "table table-hover table-no-space moenyBuilder-text-size";
}

createSummaryArr(){
    const unlockedFeatureObj =  
        this.moneyBuildInfo.gameData.unlockedFeatures.find(elem => elem.featureName === "moneyBuilder");
    const featureLevel = unlockedFeatureObj.level;
    this.summaryArr = createOverviewProfile(this.moneyBuildInfo.savingsInfo,
        this.moneyBuildInfo.summaryBuyArr, featureLevel, this.moneyBuildInfo.gameData.gameNbrMonths);
    this.summaryTotalArr = this.summaryArr.filter(item => item.subType === "");
    this.accountOverviewArr = [];
    for (let i=0; i<this.overviewTextArr.length; i++){
        const accountType = this.overviewTextArr[i].accountType;
        const summaryAccountArr = this.summaryArr.filter(item => item.accountType === accountType);
        for (let i=0; i<summaryAccountArr.length; i++){
            if (summaryAccountArr[i].subType === ""){
                summaryAccountArr[i].subType = "Total Amts";
                summaryAccountArr[i].sortNbr = +summaryAccountArr[i].sortNbr + 1;
            }
        }
        summaryAccountArr.sort((a,b) => (a.sortNbr > b.sortNbr) ? 1: -1);
        const accountOverviewObj = {...this.overviewTextArr[i], summaryArr: summaryAccountArr};
        this.accountOverviewArr.push(accountOverviewObj);
    }
    if (this.moneyBuildInfo.savingsInfo.gameID){
        this.monthlySavingsAmt = determineMonthlySavingsAmt(this.moneyBuildInfo.savingsInfo);
    }
    this.monthlyIncomeAmt = calcMonthlyIncome(this.moneyBuildInfo.gameData.assetTable,
        this.moneyBuildInfo.gameData.expenseTable, this.moneyBuildInfo.gameData.loanTable).income;
    if (this.summaryArr.length > 0){
        this.displayPortfolio = true;
    }else{
        this.displayPortfolio = false;
    }
}
  
goToNextProcess(newProcess){
    // resetting so that the investment info will be recreated when it goes back to gameView
    let nextProcess = "";
    if (newProcess === "back"){
        if (this.previousProcess !== ""){
            // remove gameInvestments which will force a reload of investment info
            this.props.setInfoRedux(true, "refreshInvestments");
            nextProcess = this.previousProcess;
        }else{
            nextProcess = "unlocked-features";
        }
    }else{
        this.props.setInfoRedux(true, "refreshInvestments");
        nextProcess = newProcess;
    }
    this.props.onNavigate(nextProcess)
}

  render() {
        this.createSummaryArr();
        this.summaryDisplay = this.summaryTotalArr.map((portfolioItem, index) =>
            <ConductorDashboardDataCard key={index} portfolioInfo={portfolioItem}
                displayPercent={true}
                summaryLevel={"total"}
            />
        );
        this.accountTypeInfo =  this.accountOverviewArr.map((summaryText, index) =>
            <ConductorDashboardInfoCard key={index} textInfo={summaryText} 
            />
        );
       
  return <>
    <div className={this.classSize}>
        <div className="card mt-2 rounded-corners-lg height-max moneyBuilder-text-size">
            <button className="pages-back-button ml-4 mt-4" 
                onClick ={()=> this.goToNextProcess("back")}>
                                Back
            </button>
            <h3 className="mt-0 text-center">Wealth Station Summary</h3>
            <div className="overflow-scroll mx-4 mb-5">
                    
                    {this.displayPortfolio ?
                    <div className="container">
                        <div className="table-responsive">
                            <table className="table text-center align-middle
                                table-hover mt-4 table-no-space ">
                                <thead>
                                    <tr>
                                        <th className="text-center table-header-middle">Account Type</th>
                                        <th className="text-center table-header-middle">
                                            <span>Out-of-Pocket</span>
                                            <br />
                                            <span>Amount</span>
                                        </th>
                                        <th className="text-right table-header-middle">Current Value</th>
                                        <th className="text-right table-header-middle">Net Change</th>
                                        <th className="text-right">Rate of <br/> Return</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.summaryDisplay}
                                </tbody>
                            </table>
                        </div>
                        {this.moneyBuildInfo.savingsInfo.gameID  ?
                            <div className="ml-2">
                                <span className="font-weight-bold">
                                    Monthly Income: &nbsp;
                                </span>
                                <span>
                                    {doubleToStringMonthly(this.monthlyIncomeAmt)}
                                </span>
                                <span className="font-weight-bold ml-5">
                                    Total Monthly Savings Amt (Bank & Retirement): &nbsp;
                                </span>
                                <span>
                                    {doubleToStringMonthly(this.monthlySavingsAmt)}
                                </span>
                            
                            </div>
                        :
                            null
                        }
                    </div>
                    :
                        <div className="mt-4">
                            You do not currently have any open accounts.  Review the information below
                            and then click the button to the right to start building your money.
                        </div>
                    }
                    <div className="mt-4">
                        {this.accountTypeInfo}
                    </div>
            </div>
  {/*          {process.env.NODE_ENV === 'development' && (
                        <div className="breakpoint-indicator" />
                        )}
    */}

        </div>
         
    </div>   
</>
  }

componentDidMount(){
    this._isMounted = true;
    
}
 

}

export default connect(mapStateToProps, mapDispatchToProps)(withLocation(ConductorDashboard));